import { useQuery, UseQueryOptions } from "@tanstack/react-query"
import { API_Error } from "@/interfaces/api/response/api_response_types"
import { getMemberships } from "../requests/memberships"
import { API_Data_Memberships_Response } from "@/interfaces/api/memberships/api_response_types"

type MembershipsOptions = Omit<
  UseQueryOptions<API_Data_Memberships_Response, API_Error, API_Data_Memberships_Response, ['memberships', string, string?]>,
  'queryKey' | 'queryFn'
>

export const useMemberships = (locale: string, code?: string, options?: MembershipsOptions) => 
  useQuery<API_Data_Memberships_Response, API_Error, API_Data_Memberships_Response, ['memberships', string, string?]>({
    queryKey: ['memberships', locale, code],
    retry: false,
    queryFn: () => getMemberships(locale, code),
    ...options
  })